/**
 * Created by Darius on 2017.04.02.
 */
import fetch from 'isomorphic-fetch';

const options = {
    credentials: 'same-origin',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

const Auth = {
    login: (username, password) =>
        fetch('/api/user/login', Object.assign({}, options, {
            method: 'POST',
            body: JSON.stringify(
                {
                    __RequestVerificationToken: document.getElementsByName("__RequestVerificationToken")[0] ? document.getElementsByName("__RequestVerificationToken")[0].value : '',
                    UserName: username,
                    Password: password
                }
            )
        })),
    logout: (username, password) =>
        fetch('/api/user/logout', Object.assign({}, options, {
            method: 'GET'
        }))
};

export default {
    Auth,
    loggedIn() {
        return !!localStorage.token;
    }
};